// @flow

export const PermissionEnum: { [string]: string } = {
  ACCESS_ADMIN: "app.access.admin",
  ACCESS_ADMIN_CLIENT: "app.access.admin.client",
  ACCESS_ADMIN_DATA: "app.access.admin.data",
  ACCESS_ADMIN_DATA_SET_DATE_RECEIVED: "app.access.admin.data.set-date-received",
  ACCESS_ADMIN_EMPLOYEE: "app.access.admin.employee",
  ACCESS_ADMIN_EMPLOYEE_MEDICAL_DETAILS: "app.access.admin.employee-medical",
  ACCESS_ADMIN_HIERARCHY: "app.access.admin.hierarchy",
  ACCESS_ADMIN_SERVICE: "app.access.admin.service-config",
  ACCESS_REPORTING: "app.access.reporting",
  ACCESS_REPORTING_FOCUS_LIST: "app.access.reporting.focus-list",
  ACCESS_REPORTING_REPORTS: "app.access.reporting.reports",
  ACCESS_REPORTING_TOOLS: "app.access.reporting.tools",
  ACCESS_REPORTING_TRENDS: "app.access.reporting.trends",
  ACCESS_REPORTING_EMPLOYEES: "app.access.reporting.employees",
  ACCESS_REPORTING_MANAGERS: "app.access.reporting.managers",
  ACCESS_REPORTING_TRAINING: "app.access.reporting.training",
  ACCESS_REPORTING_REFERRALS: "app.access.reporting.referrals",
  ACCESS_REPORTING_PRESENTATIONS: "app.access.reporting.mi-report",
  APP_GLOBAL_CONTEXT_SWITCH: "app.global.context.switch",
  PRIVILEGE_EMPLOYEE_ABSENCE_CONSENT_TO_SHARE_UPDATE:
    "privilege.employee.absence.consent-to-share.update",
  PRIVILEGE_EMPLOYEE_ABSENCE_CREATE: "privilege.employee.absence.create",
  PRIVILEGE_EMPLOYEE_ABSENCE_UPDATE: "privilege.employee.absence.update",
  PRIVILEGE_EMPLOYEE_ABSENCE_CANCEL: "privilege.employee.absence.cancel",
  PRIVILEGE_EMPLOYEE_ABSENCE_DELETE: "privilege.employee.delete",
  PRIVILEGE_EMPLOYEE_ABSENCE_TRANSFER: "privilege.employee.absence.transfer",
  PRIVILEGE_EMPLOYEE_IMPERSONATE: "privilege.employee.impersonate",
  PRIVILEGE_CLINICAL_INCIDENT: "privilege.clinical-incident",
  PRIVILEGE_CLINICAL_INCIDENT_UPDATE: "privilege.clinical-incident.update",
  PRIVILEGE_CLINICAL_INCIDENT_READ: "privilege.clinical-incident.read",
  PRIVILEGE_CLINICAL_INCIDENT_CREATE: "privilege.clinical-incident.create",
  PRIVILEGE_EMPLOYEE_NOTIFICATION_CONTACTS_OPERATIONS:
    "privilege.employee.notification-contacts.operations",
  ACCESS_REPORTING_HEALTH: "app.access.reporting.health",
  ACCESS_REPORTING_PROVIDERS: "app.access.reporting.provider-management",
  ACCESS_MY_GOODSHAPE: "app.access.self-service",
  ACCESS_MY_SERVICE_DESK: "app.access.service-desk",
  PRIVILEGE_TASKS_CANCEL: "privilege.tasks.cancel",
  PRIVILEGE_TASKS_DELETE: "privilege.tasks.delete",
  PRIVILEGE_MY_EMPLOYEES: "privilege.my-employees",
  PRIVILEGE_REPORTS_KPI_COMPLIANCE: "privilege.reports.absence-monitoring-kpi",
  PRIVILEGE_MANUAL_REFERRAL_WRITE: "privilege.referrals.manual.write",
  PRIVILEGE_AI_TEAM_SETTINGS: "privilege.ai-team.settings.update",
  PRIVILEGE_AI_TEAM_SETTINGS_READ: "privilege.ai-team.settings.read",
  PRIVILEGE_AI_TEAM_BOMAN: "privilege.ai-team.boman",
  PRIVILEGE_AI_TEAM_CLAUDIA: "privilege.ai-team.claudia",
  PRIVILEGE_AI_TEAM_MORGAN: "privilege.ai-team.morgan",
  PRIVILEGE_AI_TEAM_SHANI: "privilege.ai-team.shani",
  PRIVILEGE_DEVELOPER_ACCESS: "privilege.developer.access",
};

export const ClientPermissionEnum: { [string]: string } = {
  EAP_SIGNPOSTING: "eapSignposting",
  REFERRAL_TRACKING: "referralTracking",
  ABSENCE_MONITORING: "absenceMonitoring",
};
